import axiosInstance from 'src/api/axios';

import { TenantType } from 'src/types';
import { DefaultResponse } from 'src/api/api.types';
import { queryParamsBuilder } from 'src/utils';
import { CreateTenantPayload, UpdateTenantRequest } from './tenant.types';

class TenantService {
  private api = axiosInstance;

  public getMany = (params: any): Promise<any> => {
    return this.api.get(`tenants/${queryParamsBuilder(params)}`);
  };

  public get = (id: number): Promise<DefaultResponse<TenantType>> => {
    return this.api.get(`tenants/${id}`);
  };

  public create = (body: CreateTenantPayload): Promise<DefaultResponse<number>> => {
    return this.api.post('tenants', body);
  };

  public update = ({ id, body }: UpdateTenantRequest): Promise<void> => {
    return this.api.patch(`tenants/${id}`, body);
  };

  public delete = (id: number): Promise<any> => {
    return this.api.delete(`tenants/${id}`);
  };
}

export const tenantService = new TenantService();
